$(function(){
    $('sticky-header .btn_top-wrap img').on('click', function () {
        $('html, body').animate({ scrollTop: 0 }, 0);
    });
    // $('.drawer_open').on('click', function() {
    //     $('.nav_content').css('display','block');
    //     $('.header-view2').css('display','none');
    // });
    // $('.nav_content_drawer').on('click', function() {
    //     $('.nav_content').css('display','none');
    //     $('.header-view2').css('display','block');
    // });
});